export const PRIMARY_COLOR = '#0099FF';


// WEBPACK FOOTER //
// ./src/constants/color.tsx